<template>
    <div class="Admin-Companies-Home">
        <h1>Administration der Firmen</h1>

        <ManageCompanies :page="parseInt(page) || 1"/>

    </div>
</template>

<script>
    // @ is an alias to /src
    import ManageCompanies from '@/components/admin/ManageCompanies';

    export default {
        name: 'AdminCompanies',
        props: {
            page: String
        },
        components: {
            ManageCompanies,
        },
        methods: {

        },
    }
</script>

